// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"490a8d48","732":"6cd40acb"}[chunkId] + ".chunk.js";
};